/**
 * ProductOrderListContainer
 * --
 */
import React from 'react';
import ProductOrderListPresenter from './ProductOrderListPresenter';

const ProductOrderListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProductOrderListPresenter />
    </>
  );
};

export default ProductOrderListContainer;
